import { render, staticRenderFns } from "./OverAktsVisModal.vue?vue&type=template&id=55f37072&"
import script from "./OverAktsVisModal.vue?vue&type=script&lang=js&"
export * from "./OverAktsVisModal.vue?vue&type=script&lang=js&"
import style0 from "./OverAktsVisModal.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports